export const sortAlphabeticallyHuman = (a, b) => {
  const firstName = a.toLowerCase() ?? '';
  const lastName = b.toLowerCase() ?? '';

  if (firstName < lastName) return -1;
  else if (firstName > lastName) return 1;
  else return 0;
};
